import { Transform } from 'class-transformer';
import { IsNotEmpty } from 'class-validator';
import { sanitizeString } from '../utils';

export class CasePickupContactDto {
  @Transform(({ value }) => sanitizeString(value))
  @IsNotEmpty()
  public name: string;

  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  public email: string;

  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  public countryCode: string;

  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  public phone: string;

  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  public country: string;
}
